import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function ImeiIcon(props) {
  return (
    <SvgIcon {...props} viewBox='0 0 122.88 91.17'><path d="M35,0H46.66V53.6H35V0ZM21.56,63.62h7.72V91.17H21.56V63.62Zm13.74,0H45.46l3.87,16.76,3.88-16.76H63.32V91.17H57v-21l-4.86,21H46.45l-4.85-21v21H35.3V63.62Zm33.5,0H89.41v5.89H76.53v4.38H88.47v5.62H76.53v5.43H89.79v6.23h-21V63.62Zm26,0h7.73V91.17H94.83V63.62ZM0,0H11.66V91.17H0V0ZM72.69,0H81V53.6H72.69V0ZM56.56,0H62.8V53.6H56.56V0Zm-35,0H25.1V53.6H21.56V0Zm90.92,0h10.4V91.17h-10.4V0ZM90.92,0h11.66V53.6H90.92V0Z"/></SvgIcon>
  )
}